import makeStyles from '@mui/styles/makeStyles';
import { styled } from "@mui/material/styles";

export const Text = styled("span")(() => ({
  color: "#1D2939",
  fontFamily: "Manrope",
  fontSize: "0.875rem",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.25px",
}));

export const Wrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
}));

const styles = makeStyles(() => ({
  mainDiv: {
    minHeight: "inherit",
  },
  topSpacer: {
    marginTop: "30px",
  },
  bottomSpacer: {
    marginBottom: "24px",
  },
  container: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    height: "100%",
  },
  titleMap: {
    fontSize: "18px",
    fontWeight: 700,
    color: "#465869",
    marginBottom: 2,
    fontFamily: "Manrope",
  },
  title: {
    fontSize: "18px",
    fontWeight: 700,
    color: "#465869",
    marginBottom: "24px",
    fontFamily: "Manrope",
  },
  subtitle: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#9CA6AF",
    marginBottom: "8px",
    whiteSpace: "nowrap",
    fontFamily: "Manrope",
  },
  text: {
    fontSize: "14px",
    fontWeight: 500,
    color: "#465869",
    marginBottom: "24px",
    fontFamily: "Manrope",
  },
  infoGrid: {
    marginTop: "10px",
  },
  iconButton: {
    background: "#308CDB",
    color: "#fff",
    pointerEvents: "none",
  },
  loading: {
    position: "absolute",
    top: "0",
    left: "0",
    zIndex: 999,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    width: "100%",
    background: "rgba(0, 0, 0, 0.1)",
  },
  cancelButton: {
    padding: "0px",
    marginTop: "20px",
  },
  lineSeparator: {
    width: "inherit",
    marginTop: "20px",
    marginBottom: "0px",
    border: "1px solid #E0E2E7",
  },
  summarySpan: {
    font: "700 14px/24px Manrope",
    color: "#9ca6af",
    marginBottom: 4,
  },
  summaryText: {
    font: "500 14px/24px Manrope",
    color: "#465869",
  },
  mb16: {
    marginBottom: 16,
  },
  finalPortNameClass: {
    "@media (min-width: 1024px)": {
      marginRight: "20px !important",
    },
  },
}));

export default styles;
